import React from "react";
import "../spinner.css"; // Import the CSS for the spinner

const Spinner = ({ spinnerColor }) => {
  return (
    <div className="spinner-container">
      <div
        className="spinner"
        style={{ borderColor: spinnerColor ? spinnerColor : "white" }}
      ></div>
    </div>
  );
};

export default Spinner;
